(() => {
  const anchor = '#hf-hoodie-kaufen';
  const jump = (target) => {
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    target.focus({ preventScroll: true });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hf-logo-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    const target = document.getElementById(anchor.slice(1));
    if (!target) {
      event.preventDefault();
      location.assign(link.dataset.hfLogoHome);
      return;
    }
    event.preventDefault();
    if (location.hash !== anchor) history.pushState(null, '', anchor);
    jump(target);
  });
  window.addEventListener('load', () => {
    if (location.hash !== anchor) return;
    const target = document.getElementById(anchor.slice(1));
    if (target) jump(target);
  }, { once: true });
})();
